<template>
  <el-dialog :visible.sync="visiable" title="法人一证通Ukey密码" width="340px">
    <el-input
      type="password"
      v-model="pin"
      style="width: 249px"
      placeholder="请输入法人一证通Ukey密码"
    ></el-input>
    <template slot="footer">
      <div class="ukey_dialog_button" @click="visiable = false">取消</div>
      <!-- <el-button style="background: #CA3340">确定</el-button> -->
      <div class="ukey_dialog_button submit" @click="submit">确认</div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visiable: false,
      pin: "",
    };
  },
  methods: {
    show() {
      this.visiable = true;
      this.pin = "";
    },
    submit() {
        this.visiable = false
      this.$emit("submit", this.pin);
    },
  },
};
</script>

<style lang="scss" scoped>
.ukey {
  &_dialog_button {
    display: inline-block;
    width: 65px;
    height: 32px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 32px;
    cursor: pointer;
  }
}
.submit {
  background: #ca3340;
  color: #ffffff;
  margin-left: 12px;
}
</style>